import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { CustomerService } from 'src/app/services/customer.service';
import { GeneralService } from 'src/app/services/general.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-admin-plans-component',
  templateUrl: './admin-plans.component.html',
  styleUrls: ['./admin-plans.component.css']
})
export class AdminPlansComponent implements OnInit {
  @ViewChild('deleteCustomerBenTri') deleteCustomerBenTri: ElementRef;
  @ViewChild('seeCustomerBenTri') seeCustomerBenTri: ElementRef;
  @ViewChild('addSpeModal') addSpeModal: ElementRef;

  cBenefitsTypes: any[] = [];
  cBenefits: any[] = [];
  customers: any[] = [];
  specialityList: any[] = [];

  addPlanForm: FormGroup;
  editPlanForm: FormGroup;
  specialityForm: FormGroup;

  addFormSubmitted = false;
  editFormSubmitted = false;
  specialityFormSubmitted = false;

  editCustomerBenSelected: any = this.getEmptyEditPlan();
  deleteCustomerBenSelected: any = {};
  detailCustomerBenSelected: any = {};
  newCustomerBen: any = this.getEmptyNewPlan();

  newSpe: any = this.getEmptySpeciality();
  newMedia: any = {};

  steps: any = {
    table: false,
    add: false,
    edit: false
  };

  showSpecialityForm = false;

  constructor(
    private customerService: CustomerService,
    private generalService: GeneralService,
    private renderer: Renderer2,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.initializeForms();
    this.postListarCustomer();
    this.postListarCBenefits();
    this.getSpecialityList();
    this.changeStep({ table: true });
  }

  private initializeForms(): void {
    this.addPlanForm = this.createPlanForm();
    this.editPlanForm = this.createPlanForm();
    this.specialityForm = this.createSpecialityForm();

    this.configureSubscriptionValidation(this.addPlanForm);
    this.configureSubscriptionValidation(this.editPlanForm);
  }

  private createPlanForm(): FormGroup {
    return this.fb.group({
      // 1. Información general: obligatorio.
      cus_ben_name: ['', [Validators.required, Validators.minLength(2)]],
      cus_ben_cus_id: ['', Validators.required],
      cus_ben_cus_ben_typ_id: ['', Validators.required],
      cus_ben_is_suscription: [null, Validators.required],
      cus_ben_particular: [null, Validators.required],
      cus_ben_qty_beneficiaries: ['', [Validators.required, Validators.min(0)]],
      cus_ben_code: ['', Validators.required],
      cus_ben_phone: ['', Validators.required],
      cus_ben_base_informada: [null, Validators.required],
      cus_ben_mail_contact: ['', [Validators.required, Validators.email]],
      cus_ben_order: ['', [Validators.required, Validators.min(0)]],
      cus_ben_horario_habil: ['', Validators.required],
      cus_ben_horario_no_habil: ['', Validators.required],

      // 2. Contenido del plan: textos libres, todos opcionales.
      cus_ben_description: [''],
      cus_ben_text_welcome: [''],
      cus_ben_text_consideraciones: [''],

      // 3. Suscripción: validadores dinámicos.
      cus_ben_price_titular: [''],
      cus_ben_price_carga1: [''],
      cus_ben_price_carga2: [''],
      cus_ben_fecha_facturacion: [''],
      cus_ben_free_days: [''],

      // Secciones gestionadas como archivo/arreglos.
      cus_ben_image: [null, Validators.required],
      cus_ben_specialities: [[], Validators.required],
      cus_ben_media: [[], Validators.required]
    });
  }

  private createSpecialityForm(): FormGroup {
    return this.fb.group({
      spe_id: ['', Validators.required],

      // Se mantienen opcionales porque vacío significa "Ilimitadas".
      cty_titular: [null],
      cty_beneficiary: [null],

      disc_titular: [
        100,
        [Validators.required, Validators.min(1), Validators.max(100)]
      ],
      disc_beneficiary: [
        100,
        [Validators.required, Validators.min(1), Validators.max(100)]
      ],
      spe_order: ['', [Validators.required, Validators.min(0)]]
    });
  }

  private configureSubscriptionValidation(form: FormGroup): void {
    const subscriptionControl = form.get('cus_ben_is_suscription');

    if (!subscriptionControl) {
      return;
    }

    subscriptionControl.valueChanges.subscribe((value: any) => {
      this.updateSubscriptionValidators(
        form,
        this.isSubscriptionValue(value)
      );
    });

    this.updateSubscriptionValidators(
      form,
      this.isSubscriptionValue(subscriptionControl.value)
    );
  }

  private updateSubscriptionValidators(
    form: FormGroup,
    isSubscription: boolean
  ): void {
    const numericFields = [
      'cus_ben_price_titular',
      'cus_ben_price_carga1',
      'cus_ben_price_carga2',
      'cus_ben_free_days'
    ];

    const allFields = [
      ...numericFields,
      'cus_ben_fecha_facturacion'
    ];

    allFields.forEach((field: string) => {
      const control = form.get(field);

      if (!control) {
        return;
      }

      if (isSubscription) {
        if (numericFields.includes(field)) {
          control.setValidators([
            Validators.required,
            Validators.min(0)
          ]);
        } else {
          control.setValidators(Validators.required);
        }
      } else {
        control.clearValidators();
        control.setValue('', { emitEvent: false });
      }

      control.updateValueAndValidity({ emitEvent: false });
    });
  }

  postListarCustomer(): void {
    this.customers = [];

    this.customerService.postListarCustomer({})
      .then((result: any) => {
        this.customers = result;
      })
      .catch(() => { });
  }

  postListarCBenefits(): void {
    this.cBenefits = [];
    this.cBenefitsTypes = [];

    this.generalService.modalCargando();

    this.customerService.postListarCBenefits()
      .then((result: any) => {
        this.cBenefits = result.planes && result.planes.length > 0
          ? result.planes
          : [];

        this.cBenefitsTypes = result.tipos && result.tipos.length > 0
          ? result.tipos
          : [];

        Swal.close();
      })
      .catch(() => {
        this.generalService.modalError(
          'Error',
          'Error al cargar planes.'
        );
      });
  }

  addCustomerBenefits(): void {
    this.newCustomerBen = this.getEmptyNewPlan();
    this.addFormSubmitted = false;

    this.addPlanForm.reset({
      cus_ben_is_suscription: null,
      cus_ben_particular: null,
      cus_ben_base_informada: null,
      cus_ben_image: null,
      cus_ben_specialities: [],
      cus_ben_media: []
    });

    this.updateSubscriptionValidators(this.addPlanForm, false);
    this.changeStep({ add: true });
  }

  deleteCustomerBenefits(cBenefit: any): void {
    this.deleteCustomerBenSelected = cBenefit;
    this.renderer.selectRootElement(
      this.deleteCustomerBenTri.nativeElement
    ).click();
  }

  editCustomerBenefits(cBenefit: any): void {
    this.changeStep({ edit: true });

    this.editCustomerBenSelected = JSON.parse(JSON.stringify(cBenefit));
    this.editCustomerBenSelected.cus_ben_cus_id =
      this.editCustomerBenSelected.cus_id;

    this.editCustomerBenSelected.new_cus_ben_media = [];
    this.editCustomerBenSelected.cus_ben_media = cBenefit.cus_ben_media
      ? cBenefit.cus_ben_media
      : [];

    this.editCustomerBenSelected.new_cus_ben_specialities = [];

    this.editCustomerBenSelected.cus_ben_specialities =
      Array.isArray(cBenefit.cus_ben_specialities)
        ? cBenefit.cus_ben_specialities.map((spe: any) => ({
          ...spe,
          spe_order:
            spe?.spe_order ??
            spe?.order ??
            spe?.cus_ben_det_order ??
            spe?.cus_ben_spe_order ??
            ''
        }))
        : [];

    this.editCustomerBenSelected.cus_ben_is_suscription =
      this.toBooleanOrNull(
        this.editCustomerBenSelected.cus_ben_is_suscription
      );

    this.editCustomerBenSelected.cus_ben_particular =
      this.toBooleanOrNull(
        this.editCustomerBenSelected.cus_ben_particular
      );

    this.editCustomerBenSelected.cus_ben_base_informada =
      this.toBooleanOrNull(
        this.editCustomerBenSelected.cus_ben_base_informada
      );

    this.editCustomerBenSelected.cus_ben_fecha_facturacion =
      this.formatDateForInput(
        this.editCustomerBenSelected.cus_ben_fecha_facturacion
      );

    this.editCustomerBenSelected.cus_ben_price_titular =
      this.editCustomerBenSelected.cus_ben_price_titular ?? '';

    this.editCustomerBenSelected.cus_ben_price_carga1 =
      this.editCustomerBenSelected.cus_ben_price_carga1 ?? '';

    this.editCustomerBenSelected.cus_ben_price_carga2 =
      this.editCustomerBenSelected.cus_ben_price_carga2 ?? '';

    this.editCustomerBenSelected.cus_ben_free_days =
      this.editCustomerBenSelected.cus_ben_free_days ?? '';

    this.editCustomerBenSelected.cus_ben_order =
      this.editCustomerBenSelected.cus_ben_order ??
      this.editCustomerBenSelected.order ??
      '';

    this.editCustomerBenSelected.cus_ben_horario_habil =
      this.editCustomerBenSelected.cus_ben_horario_habil ||
      this.editCustomerBenSelected.cus_ben_horario_atencion_habil ||
      '';

    this.editCustomerBenSelected.cus_ben_horario_no_habil =
      this.editCustomerBenSelected.cus_ben_horario_no_habil ||
      this.editCustomerBenSelected.cus_ben_horario_atencion_no_habil ||
      '';

    delete this.editCustomerBenSelected.order;
    delete this.editCustomerBenSelected.cus_ben_horario_atencion_habil;
    delete this.editCustomerBenSelected.cus_ben_horario_atencion_no_habil;

    this.editFormSubmitted = false;

    this.editPlanForm.reset();
    this.editPlanForm.patchValue({
      cus_ben_name: this.editCustomerBenSelected.cus_ben_name ?? '',
      cus_ben_cus_id: this.editCustomerBenSelected.cus_ben_cus_id ?? '',
      cus_ben_cus_ben_typ_id:
        this.editCustomerBenSelected.cus_ben_cus_ben_typ_id ?? '',
      cus_ben_is_suscription:
        this.editCustomerBenSelected.cus_ben_is_suscription,
      cus_ben_particular:
        this.editCustomerBenSelected.cus_ben_particular,
      cus_ben_qty_beneficiaries:
        this.editCustomerBenSelected.cus_ben_qty_beneficiaries ?? '',
      cus_ben_code: this.editCustomerBenSelected.cus_ben_code ?? '',
      cus_ben_phone: this.editCustomerBenSelected.cus_ben_phone ?? '',
      cus_ben_base_informada:
        this.editCustomerBenSelected.cus_ben_base_informada,
      cus_ben_mail_contact:
        this.editCustomerBenSelected.cus_ben_mail_contact ?? '',
      cus_ben_order: this.editCustomerBenSelected.cus_ben_order ?? '',
      cus_ben_horario_habil:
        this.editCustomerBenSelected.cus_ben_horario_habil ?? '',
      cus_ben_horario_no_habil:
        this.editCustomerBenSelected.cus_ben_horario_no_habil ?? '',

      // Punto 2: sin Validators.required.
      cus_ben_description:
        this.editCustomerBenSelected.cus_ben_description ?? '',
      cus_ben_text_welcome:
        this.editCustomerBenSelected.cus_ben_text_welcome ?? '',
      cus_ben_text_consideraciones: 
      this.editCustomerBenSelected.cus_ben_text_consideraciones ?? '',

      cus_ben_price_titular:
        this.editCustomerBenSelected.cus_ben_price_titular ?? '',
      cus_ben_price_carga1:
        this.editCustomerBenSelected.cus_ben_price_carga1 ?? '',
      cus_ben_price_carga2:
        this.editCustomerBenSelected.cus_ben_price_carga2 ?? '',
      cus_ben_fecha_facturacion:
        this.editCustomerBenSelected.cus_ben_fecha_facturacion ?? '',
      cus_ben_free_days:
        this.editCustomerBenSelected.cus_ben_free_days ?? '',

      cus_ben_image:
        this.editCustomerBenSelected.cus_ben_image ?? null,
      cus_ben_specialities:
        this.getAllEditSpecialities(),
      cus_ben_media:
        this.getAllEditMedia()
    });

    this.updateSubscriptionValidators(
      this.editPlanForm,
      this.isFormSubscription(this.editPlanForm)
    );
  }

  cancelEdit(): void {
    this.ngOnInit();
  }

  confirmDelete(): void {
    if (!this.deleteCustomerBenSelected.cus_ben_id) {
      this.generalService.modalError(
        'Falta información',
        'Debe seleccionar un plan.'
      );
      return;
    }

    this.generalService.modalCargando();
    this.renderer.selectRootElement(
      this.deleteCustomerBenTri.nativeElement
    ).click();

    this.customerService
      .postEliminarCBenefits(this.deleteCustomerBenSelected.cus_ben_id)
      .then(async () => {
        this.generalService.modalExitoso(
          'Plan eliminado',
          'El plan se eliminó exitosamente.'
        );

        await this.generalService.sleep(1000);
        this.ngOnInit();
      })
      .catch(() => {
        this.generalService.modalError(
          'Error al eliminar',
          'Error al eliminar plan.'
        );
      });
  }

  onFileSelectedEdit(event: any): void { }

  changeStep({
    table = false,
    add = false,
    edit = false
  }: {
    table?: boolean;
    add?: boolean;
    edit?: boolean;
  }): void {
    this.steps = {
      table,
      add,
      edit
    };

    this.showSpecialityForm = false;
    this.resetNewSpe();
  }

  isPlanSubscription(plan: any): boolean {
    return !!plan && this.isSubscriptionValue(
      plan.cus_ben_is_suscription
    );
  }

  isFormSubscription(form: FormGroup): boolean {
    return this.isSubscriptionValue(
      form.get('cus_ben_is_suscription')?.value
    );
  }

  private isSubscriptionValue(value: any): boolean {
    return value === true || value === 'true';
  }

  getPlanStepNumber(step: string, planOrForm: any): number {
    const isSubscription = planOrForm instanceof FormGroup
      ? this.isFormSubscription(planOrForm)
      : this.isPlanSubscription(planOrForm);

    const planSteps: any = isSubscription
      ? {
        general: 1,
        content: 2,
        prices: 3,
        image: 4,
        specialities: 5,
        waitingRoom: 6
      }
      : {
        general: 1,
        content: 2,
        image: 3,
        specialities: 4,
        waitingRoom: 5
      };

    return planSteps[step];
  }

  toBooleanOrNull(value: any): boolean | null {
    if (value === true || value === 'true') {
      return true;
    }

    if (value === false || value === 'false') {
      return false;
    }

    return null;
  }

  clearSubscriptionFields(plan: any): void {
    if (!plan) {
      return;
    }

    plan.cus_ben_price_titular = '';
    plan.cus_ben_price_carga1 = '';
    plan.cus_ben_price_carga2 = '';
    plan.cus_ben_fecha_facturacion = '';
    plan.cus_ben_free_days = '';
  }

  cancelAdd(): void {
    this.ngOnInit();
  }

  seeDetails(cBenefit: any): void {
    this.detailCustomerBenSelected = cBenefit;
    this.renderer.selectRootElement(
      this.seeCustomerBenTri.nativeElement
    ).click();
  }

  confirmAdd(): void {
    this.addFormSubmitted = true;
    this.syncAddCollections();

    if (this.addPlanForm.invalid) {
      this.addPlanForm.markAllAsTouched();

      this.generalService.modalError(
        'Formulario incompleto',
        'Debe completar todos los campos obligatorios antes de crear el plan.'
      );
      return;
    }

    const formValue = this.addPlanForm.getRawValue();

    this.newCustomerBen = {
      ...this.newCustomerBen,
      ...this.getNormalizedPlanValues(formValue),
      cus_ben_image: this.newCustomerBen.cus_ben_image,
      cus_ben_media: this.newCustomerBen.cus_ben_media || [],
      cus_ben_specialities:
        (this.newCustomerBen.cus_ben_specialities || [])
          .map((spe: any) => this.normalizeNewSpeciality(spe))
    };

    if (!this.newCustomerBen.cus_ben_is_suscription) {
      this.clearSubscriptionFields(this.newCustomerBen);
    }

    delete this.newCustomerBen.order;
    delete this.newCustomerBen.cus_ben_horario_atencion_habil;
    delete this.newCustomerBen.cus_ben_horario_atencion_no_habil;

    console.log('Payload crear plan:', this.newCustomerBen);

    this.generalService.modalCargando();

    this.customerService
      .postCrearCBenefits(this.newCustomerBen)
      .then(async (result: any) => {
        console.log('Plan creado:', result);

        this.generalService.modalExitoso(
          'Plan creado',
          'El plan se creó exitosamente.'
        );

        await this.generalService.sleep(1000);
        this.ngOnInit();
      })
      .catch((error: any) => {
        console.error('Error al crear plan:', error);

        this.generalService.modalError(
          'Error al crear',
          'Error al crear plan.'
        );
      });
  }

  confirmEdit(): void {
    this.editFormSubmitted = true;
    this.syncEditCollections();

    if (this.editPlanForm.invalid) {
      this.editPlanForm.markAllAsTouched();

      this.generalService.modalError(
        'Formulario incompleto',
        'Debe completar todos los campos obligatorios antes de editar el plan.'
      );
      return;
    }

    const formValue = this.editPlanForm.getRawValue();

    this.editCustomerBenSelected = {
      ...this.editCustomerBenSelected,
      ...this.getNormalizedPlanValues(formValue),
      cus_ben_image: this.editCustomerBenSelected.cus_ben_image,
      cus_ben_media: this.editCustomerBenSelected.cus_ben_media || [],
      new_cus_ben_media:
        this.editCustomerBenSelected.new_cus_ben_media || [],
      cus_ben_specialities:
        (this.editCustomerBenSelected.cus_ben_specialities || [])
          .map((spe: any) => this.normalizeExistingSpeciality(spe)),
      new_cus_ben_specialities:
        (this.editCustomerBenSelected.new_cus_ben_specialities || [])
          .map((spe: any) => this.normalizeNewSpeciality(spe))
    };

    if (!this.editCustomerBenSelected.cus_ben_is_suscription) {
      this.clearSubscriptionFields(this.editCustomerBenSelected);
    }

    delete this.editCustomerBenSelected.order;
    delete this.editCustomerBenSelected.cus_ben_horario_atencion_habil;
    delete this.editCustomerBenSelected.cus_ben_horario_atencion_no_habil;

    console.log(
      'Payload editar plan:',
      this.editCustomerBenSelected
    );

    this.generalService.modalCargando();

    this.customerService
      .postCrearCBenefits(this.editCustomerBenSelected)
      .then(async (result: any) => {
        this.generalService.modalExitoso(
          'Plan modificado',
          'El plan se modificó exitosamente.'
        );

        console.log('Plan modificado:', result);

        await this.generalService.sleep(1000);
        this.ngOnInit();
      })
      .catch((error: any) => {
        console.error('Error al modificar plan:', error);

        this.generalService.modalError(
          'Error al modificar',
          'Error al modificar plan.'
        );
      });
  }

  private getNormalizedPlanValues(formValue: any): any {
    const isSubscription = this.isSubscriptionValue(
      formValue.cus_ben_is_suscription
    );

    return {
      cus_ben_name: String(formValue.cus_ben_name || '').trim(),
      cus_ben_cus_id: formValue.cus_ben_cus_id,
      cus_ben_qty_beneficiaries:
        Number(formValue.cus_ben_qty_beneficiaries),
      cus_ben_code: String(formValue.cus_ben_code || '').trim(),
      cus_ben_cus_ben_typ_id: formValue.cus_ben_cus_ben_typ_id,
      cus_ben_is_suscription: isSubscription,

      // Punto 2: opcional.
      cus_ben_description: formValue.cus_ben_description || '',
      cus_ben_text_welcome: formValue.cus_ben_text_welcome || '',
      cus_ben_text_consideraciones: formValue.cus_ben_text_consideraciones || '',

      cus_ben_phone: String(formValue.cus_ben_phone || '').trim(),
      cus_ben_particular:
        formValue.cus_ben_particular === true ||
        formValue.cus_ben_particular === 'true',
      cus_ben_base_informada:
        formValue.cus_ben_base_informada === true ||
        formValue.cus_ben_base_informada === 'true',
      cus_ben_mail_contact:
        String(formValue.cus_ben_mail_contact || '').trim(),
      cus_ben_order: this.getOrderNumber(formValue.cus_ben_order),
      cus_ben_horario_habil:
        String(formValue.cus_ben_horario_habil || '').trim(),
      cus_ben_horario_no_habil:
        String(formValue.cus_ben_horario_no_habil || '').trim(),

      cus_ben_price_titular: isSubscription
        ? Number(formValue.cus_ben_price_titular)
        : '',
      cus_ben_price_carga1: isSubscription
        ? Number(formValue.cus_ben_price_carga1)
        : '',
      cus_ben_price_carga2: isSubscription
        ? Number(formValue.cus_ben_price_carga2)
        : '',
      cus_ben_fecha_facturacion: isSubscription
        ? formValue.cus_ben_fecha_facturacion
        : '',
      cus_ben_free_days: isSubscription
        ? Number(formValue.cus_ben_free_days)
        : ''
    };
  }

  private normalizeNewSpeciality(spe: any): any {
    const {
      order,
      cus_ben_det_order,
      cus_ben_spe_order,
      ...speciality
    } = spe;

    return {
      ...speciality,
      spe_order: this.getOrderNumber(
        spe.spe_order ??
        cus_ben_spe_order ??
        order ??
        cus_ben_det_order
      )
    };
  }

  private normalizeExistingSpeciality(spe: any): any {
    const {
      order,
      cus_ben_det_order,
      cus_ben_spe_order,
      ...speciality
    } = spe;

    return {
      ...speciality,
      spe_order: this.getOrderNumber(
        spe.spe_order ??
        cus_ben_spe_order ??
        order ??
        cus_ben_det_order
      )
    };
  }

  private syncAddCollections(): void {
    this.addPlanForm.patchValue(
      {
        cus_ben_image: this.newCustomerBen.cus_ben_image,
        cus_ben_specialities:
          this.newCustomerBen.cus_ben_specialities || [],
        cus_ben_media:
          this.newCustomerBen.cus_ben_media || []
      },
      { emitEvent: false }
    );

    this.updateCollectionValidity(this.addPlanForm);
  }

  private syncEditCollections(): void {
    this.editPlanForm.patchValue(
      {
        cus_ben_image:
          this.editCustomerBenSelected.cus_ben_image,
        cus_ben_specialities:
          this.getAllEditSpecialities(),
        cus_ben_media:
          this.getAllEditMedia()
      },
      { emitEvent: false }
    );

    this.updateCollectionValidity(this.editPlanForm);
  }

  private updateCollectionValidity(form: FormGroup): void {
    [
      'cus_ben_image',
      'cus_ben_specialities',
      'cus_ben_media'
    ].forEach((field: string) => {
      form.get(field)?.updateValueAndValidity({ emitEvent: false });
    });
  }

  private getAllEditSpecialities(): any[] {
    return [
      ...(this.editCustomerBenSelected.cus_ben_specialities || []),
      ...(this.editCustomerBenSelected.new_cus_ben_specialities || [])
    ];
  }

  private getAllEditMedia(): any[] {
    return [
      ...(this.editCustomerBenSelected.cus_ben_media || []),
      ...(this.editCustomerBenSelected.new_cus_ben_media || [])
    ];
  }

  isFieldInvalid(
    form: FormGroup,
    field: string,
    submitted = false
  ): boolean {
    const control = form.get(field);

    if (!control) {
      return false;
    }

    return control.invalid && (
      control.touched ||
      control.dirty ||
      submitted
    );
  }

  getFieldError(form: FormGroup, field: string): string {
    const control = form.get(field);

    if (!control || !control.errors) {
      return '';
    }

    if (control.errors.required) {
      return 'Este campo es obligatorio.';
    }

    if (control.errors.email) {
      return 'Ingrese un correo electrónico válido.';
    }

    if (control.errors.minlength) {
      return `Debe ingresar al menos ${control.errors.minlength.requiredLength} caracteres.`;
    }

    if (control.errors.min) {
      return `El valor mínimo permitido es ${control.errors.min.min}.`;
    }

    if (control.errors.max) {
      return `El valor máximo permitido es ${control.errors.max.max}.`;
    }

    return 'El valor ingresado no es válido.';
  }

  getSpecialityList(): void {
    this.generalService.getSpecialityList()
      .then((data: any) => {
        if (data !== null && data.length > 0) {
          this.specialityList = data;
        }
      })
      .catch((e: any) => console.error(e));
  }

  onFileSelected(event: any): void { }

  addSpe(): boolean {
    this.specialityFormSubmitted = true;

    if (this.specialityForm.invalid) {
      this.specialityForm.markAllAsTouched();

      this.generalService.modalError(
        'Falta información',
        'Complete los campos obligatorios de la especialidad.'
      );
      return false;
    }

    this.newSpe = {
      ...this.specialityForm.getRawValue()
    };

    const specialitySelected = this.specialityList.find(
      (element: any) =>
        Number(element.spe_id) === Number(this.newSpe.spe_id)
    );

    if (!specialitySelected) {
      this.generalService.modalError(
        'Error',
        'No se encontró la especialidad seleccionada.'
      );
      return false;
    }

    const speToAdd = {
      spe_id: Number(this.newSpe.spe_id),
      spe_name: specialitySelected.spe_name,
      cty_titular: this.hasNumberValue(this.newSpe.cty_titular)
        ? Number(this.newSpe.cty_titular)
        : null,
      cty_beneficiary: this.hasNumberValue(this.newSpe.cty_beneficiary)
        ? Number(this.newSpe.cty_beneficiary)
        : null,
      disc_titular: Number(this.newSpe.disc_titular),
      disc_beneficiary: Number(this.newSpe.disc_beneficiary),
      spe_order: this.getOrderNumber(this.newSpe.spe_order)
    };

    if (this.steps.edit) {
      if (!this.editCustomerBenSelected.cus_ben_specialities) {
        this.editCustomerBenSelected.cus_ben_specialities = [];
      }

      if (!this.editCustomerBenSelected.new_cus_ben_specialities) {
        this.editCustomerBenSelected.new_cus_ben_specialities = [];
      }

      const existsInSaved =
        this.editCustomerBenSelected.cus_ben_specialities.some(
          (element: any) =>
            Number(element.spe_id) === Number(speToAdd.spe_id)
        );

      if (existsInSaved) {
        this.generalService.modalError(
          'Error',
          'Debe borrar esta especialidad antes para agregarla.'
        );
        return false;
      }

      const indexNew =
        this.editCustomerBenSelected.new_cus_ben_specialities.findIndex(
          (element: any) =>
            Number(element.spe_id) === Number(speToAdd.spe_id)
        );

      if (indexNew >= 0) {
        this.editCustomerBenSelected.new_cus_ben_specialities[indexNew] =
          speToAdd;
      } else {
        this.editCustomerBenSelected.new_cus_ben_specialities = [
          ...this.editCustomerBenSelected.new_cus_ben_specialities,
          speToAdd
        ];
      }

      this.syncEditCollections();
      return true;
    }

    if (!this.newCustomerBen.cus_ben_specialities) {
      this.newCustomerBen.cus_ben_specialities = [];
    }

    const indexAdd = this.newCustomerBen.cus_ben_specialities.findIndex(
      (element: any) =>
        Number(element.spe_id) === Number(speToAdd.spe_id)
    );

    if (indexAdd >= 0) {
      this.newCustomerBen.cus_ben_specialities[indexAdd] = speToAdd;
      this.newCustomerBen.cus_ben_specialities = [
        ...this.newCustomerBen.cus_ben_specialities
      ];
    } else {
      this.newCustomerBen.cus_ben_specialities = [
        ...this.newCustomerBen.cus_ben_specialities,
        speToAdd
      ];
    }

    this.syncAddCollections();
    return true;
  }

  deleteSpe(spe: any): void {
    if (!spe) {
      return;
    }

    if (this.steps.edit) {
      const arraySpe =
        this.editCustomerBenSelected.new_cus_ben_specialities || [];

      this.editCustomerBenSelected.new_cus_ben_specialities =
        arraySpe.filter(
          (element: any) =>
            Number(element.spe_id) !== Number(spe.spe_id)
        );

      this.syncEditCollections();
      return;
    }

    const arraySpe = this.newCustomerBen.cus_ben_specialities || [];

    this.newCustomerBen.cus_ben_specialities = arraySpe.filter(
      (element: any) =>
        Number(element.spe_id) !== Number(spe.spe_id)
    );

    this.syncAddCollections();
  }

  updateExistingSpecialityOrder(
    spe: any,
    event: Event
  ): void {
    const value = (event.target as HTMLInputElement).value;
    spe.spe_order = value;
    this.syncEditCollections();
  }

  updateNewSpecialityOrder(
    spe: any,
    event: Event
  ): void {
    const value = (event.target as HTMLInputElement).value;
    spe.spe_order = value;

    if (this.steps.edit) {
      this.syncEditCollections();
    } else {
      this.syncAddCollections();
    }
  }

  openModalSpe(): void {
    this.showInlineSpecialityForm();
  }

  addMedia(event: any): void {
    if (
      !event ||
      !event.target ||
      !event.target.files ||
      !event.target.files[0]
    ) {
      this.generalService.modalError(
        'Seleccione otro documento',
        'Documento no válido'
      );
      return;
    }

    this.newMedia = event.target.files[0];
  }

  confirmAddMedia(): void {
    if (!this.newMedia || !this.newMedia.name) {
      this.generalService.modalError(
        'Falta un documento',
        'Documento no válido'
      );
      return;
    }

    if (this.steps.edit) {
      const arrayMedia =
        this.editCustomerBenSelected.new_cus_ben_media || [];

      this.editCustomerBenSelected.new_cus_ben_media = [
        ...arrayMedia,
        this.newMedia
      ];

      this.syncEditCollections();
    } else {
      const arrayMedia =
        this.newCustomerBen.cus_ben_media || [];

      this.newCustomerBen.cus_ben_media = [
        ...arrayMedia,
        this.newMedia
      ];

      this.syncAddCollections();
    }

    /*
      El cierre del modal lo gestiona Bootstrap desde el HTML
      mediante data-dismiss="modal". De esta forma no dependemos
      de un @ViewChild/nativeElement que puede no existir en
      determinados builds de DEV/PROD.
    */
  }

  openModalMedia(): void {
    /*
      Solo limpiamos el archivo previamente seleccionado.
      El modal se abre directamente mediante:
      data-toggle="modal"
      data-target="#addMediaBen"
    */
    this.newMedia = {};
  }

  deleteMedia(index: number): void {
    if (this.steps.edit) {
      const arrayMedia = [
        ...(this.editCustomerBenSelected.new_cus_ben_media || [])
      ];

      arrayMedia.splice(index, 1);
      this.editCustomerBenSelected.new_cus_ben_media = arrayMedia;
      this.syncEditCollections();
      return;
    }

    const arrayMedia = [
      ...(this.newCustomerBen.cus_ben_media || [])
    ];

    arrayMedia.splice(index, 1);
    this.newCustomerBen.cus_ben_media = arrayMedia;
    this.syncAddCollections();
  }

  deleteMediaRoomLobby(med_roo_lob_id: any): void {
    let indexMedia: number | undefined;

    if (!med_roo_lob_id) {
      this.generalService.modalError(
        'Error',
        'Falta seleccionar un archivo'
      );
      return;
    }

    for (
      let index = 0;
      index < this.editCustomerBenSelected.cus_ben_media.length;
      index++
    ) {
      const element =
        this.editCustomerBenSelected.cus_ben_media[index];

      if (element.med_roo_lob_id == med_roo_lob_id) {
        indexMedia = index;
        break;
      }
    }

    this.generalService.modalCargando();

    this.customerService
      .deleteMediaRoomLobby({ med_roo_lob_id })
      .then(() => {
        this.generalService.modalExitoso(
          'Eliminación exitosa',
          'Se eliminó de correcta forma el archivo.'
        );

        if (indexMedia !== undefined) {
          const arrayMedia = [
            ...this.editCustomerBenSelected.cus_ben_media
          ];

          arrayMedia.splice(indexMedia, 1);
          this.editCustomerBenSelected.cus_ben_media = arrayMedia;
        }

        this.syncEditCollections();
      })
      .catch((error: any) => {
        this.generalService.modalError(
          'Error',
          error && error.error && error.error.message
            ? error.error.message
            : 'Error al eliminar archivo'
        );
      });
  }

  deleteSpeDet(cus_ben_det_id: any): void {
    let indexDet: number | undefined;

    if (!cus_ben_det_id) {
      this.generalService.modalError(
        'Error',
        'Falta seleccionar una especialidad.'
      );
      return;
    }

    for (
      let index = 0;
      index < this.editCustomerBenSelected.cus_ben_specialities.length;
      index++
    ) {
      const element =
        this.editCustomerBenSelected.cus_ben_specialities[index];

      if (element.cus_ben_det_id == cus_ben_det_id) {
        indexDet = index;
        break;
      }
    }

    this.generalService.modalCargando();

    this.customerService
      .deleteSubSpecialityDetail({ cus_ben_det_id })
      .then(() => {
        this.generalService.modalExitoso(
          'Eliminación exitosa',
          'Se eliminó de correcta forma.'
        );

        if (indexDet !== undefined) {
          const arrayDetails = [
            ...this.editCustomerBenSelected.cus_ben_specialities
          ];

          arrayDetails.splice(indexDet, 1);
          this.editCustomerBenSelected.cus_ben_specialities =
            arrayDetails;
        }

        this.syncEditCollections();
      })
      .catch((error: any) => {
        this.generalService.modalError(
          'Error',
          error && error.error && error.error.message
            ? error.error.message
            : 'Error al eliminar'
        );
      });
  }

  onFileSelectedLogo(event: any): void {
    if (
      !event ||
      !event.target ||
      !event.target.files ||
      !event.target.files[0]
    ) {
      this.generalService.modalError(
        'Seleccione otro documento',
        'Documento no válido'
      );
      return;
    }

    const file = event.target.files[0];

    if (this.steps.edit) {
      this.editCustomerBenSelected.cus_ben_image = file;

      this.editPlanForm.get('cus_ben_image')?.setValue(file);
      this.editPlanForm.get('cus_ben_image')?.markAsTouched();
      this.editPlanForm.get('cus_ben_image')?.updateValueAndValidity();
      return;
    }

    this.newCustomerBen.cus_ben_image = file;

    this.addPlanForm.get('cus_ben_image')?.setValue(file);
    this.addPlanForm.get('cus_ben_image')?.markAsTouched();
    this.addPlanForm.get('cus_ben_image')?.updateValueAndValidity();
  }

  showInlineSpecialityForm(): void {
    this.resetNewSpe();
    this.showSpecialityForm = true;
  }

  cancelInlineSpecialityForm(): void {
    this.showSpecialityForm = false;
    this.resetNewSpe();
  }

  addInlineSpeciality(): void {
    const wasAdded = this.addSpe();

    if (!wasAdded) {
      return;
    }

    this.showSpecialityForm = false;
    this.resetNewSpe();
  }

  private resetNewSpe(): void {
    this.newSpe = this.getEmptySpeciality();
    this.specialityFormSubmitted = false;

    if (this.specialityForm) {
      this.specialityForm.reset({
        spe_id: '',
        cty_titular: null,
        cty_beneficiary: null,
        disc_titular: 100,
        disc_beneficiary: 100,
        spe_order: ''
      });
    }
  }

  formatDateForInput(dateValue: any): string {
    if (!dateValue) {
      return '';
    }

    return String(dateValue).split('T')[0];
  }

  private getOrderNumber(value: any): number | null {
    if (
      value === null ||
      value === undefined ||
      value === ''
    ) {
      return null;
    }

    const order = Number(value);
    return isNaN(order) ? null : order;
  }

  private hasNumberValue(value: any): boolean {
    return !(
      value === null ||
      value === undefined ||
      value === ''
    );
  }

  private getEmptySpeciality(): any {
    return {
      spe_id: '',
      spe_name: '',
      cty_titular: null,
      cty_beneficiary: null,
      disc_titular: 100,
      disc_beneficiary: 100,
      spe_order: ''
    };
  }

  private getEmptyNewPlan(): any {
    return {
      cus_ben_name: '',
      cus_ben_cus_id: '',
      cus_ben_cus_name: '',
      cus_ben_qty_beneficiaries: '',
      cus_ben_code: '',
      cus_ben_cus_ben_typ_id: '',
      cus_ben_is_suscription: null,
      cus_ben_cus_ben_typ_name: null,
      cus_ben_description: '',
      cus_ben_phone: '',
      cus_ben_text_welcome: '',
      cus_ben_text_consideraciones: '',
      cus_ben_particular: null,
      cus_ben_base_informada: null,
      cus_ben_mail_contact: '',
      cus_ben_horario_habil: '',
      cus_ben_horario_no_habil: '',
      cus_ben_image: null,
      cus_ben_media: [],
      cus_ben_specialities: [],
      cus_ben_fecha_facturacion: '',
      cus_ben_price_titular: '',
      cus_ben_price_carga1: '',
      cus_ben_price_carga2: '',
      cus_ben_free_days: '',
      cus_ben_order: ''
    };
  }

  private getEmptyEditPlan(): any {
    return {
      cus_ben_id: '',
      cus_ben_name: '',
      cus_ben_cus_id: '',
      cus_ben_cus_name: '',
      cus_ben_qty_beneficiaries: '',
      cus_ben_code: '',
      cus_ben_cus_ben_typ_id: '',
      cus_ben_is_suscription: null,
      cus_ben_cus_ben_typ_name: null,
      cus_ben_description: '',
      cus_ben_phone: '',
      cus_ben_text_welcome: '',
      cus_ben_text_consideraciones: '',
      cus_ben_particular: null,
      cus_ben_base_informada: null,
      cus_ben_mail_contact: '',
      cus_ben_horario_habil: '',
      cus_ben_horario_no_habil: '',
      cus_ben_image: null,
      cus_ben_media: [],
      new_cus_ben_media: [],
      cus_ben_specialities: [],
      new_cus_ben_specialities: [],
      cus_ben_fecha_facturacion: '',
      cus_ben_price_titular: '',
      cus_ben_price_carga1: '',
      cus_ben_price_carga2: '',
      cus_ben_free_days: '',
      cus_ben_order: ''
    };
  }
}
